import type { TenantSummary } from "../api/types";

interface TenantTileProps {
  tenant: TenantSummary;
  onClick?: () => void;
}

export function TenantTile({ tenant, onClick }: TenantTileProps) {
  const knownDevices = tenant.device_count > 0;
  return (
    <div
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      style={{
        background: "var(--surface)",
        border: "1px solid var(--border)",
        borderRadius: 8,
        padding: 20,
        display: "flex",
        flexDirection: "column",
        gap: 12,
        minHeight: 140,
        cursor: onClick ? "pointer" : "default",
        transition: "border-color 120ms",
      }}
      onMouseEnter={(e) => onClick && (e.currentTarget.style.borderColor = "var(--accent)")}
      onMouseLeave={(e) => onClick && (e.currentTarget.style.borderColor = "var(--border)")}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h2 style={{ margin: 0, fontSize: "1.1rem" }}>{tenant.display_name}</h2>
        <code style={{ color: "var(--text-dim)", fontSize: "0.8rem" }}>{tenant.slug}</code>
      </div>
      {knownDevices ? (
        <div style={{ display: "flex", gap: 24 }}>
          <Stat label="Devices" value={tenant.device_count} />
          <Stat label="Alive" value={tenant.devices_alive} tone="ok" />
          <Stat label="Unreachable" value={tenant.devices_unreachable} tone="crit" />
        </div>
      ) : (
        <p style={{ color: "var(--text-dim)", margin: 0, fontSize: "0.9rem" }}>
          Pending onboarding
        </p>
      )}
    </div>
  );
}

interface StatProps {
  label: string;
  value: number;
  tone?: "ok" | "crit";
}

function Stat({ label, value, tone }: StatProps) {
  const color = tone === "ok" ? "var(--ok)" : tone === "crit" ? "var(--crit)" : "var(--text)";
  return (
    <div>
      <div style={{ color: "var(--text-dim)", fontSize: "0.75rem", textTransform: "uppercase" }}>
        {label}
      </div>
      <div style={{ color, fontSize: "1.5rem", fontWeight: 600 }}>{value}</div>
    </div>
  );
}
